const getWords = questions => {
    const words = []
    for (let i = 0; i < 10; i++) {
        words.push(questions[i].word)
    }
    return words
}

export default getWords